import React, { useState } from "react";
import Style from "./TransactionInfo.module.css";
import { convertDate } from "../../../Utils/Helper/Helper";
import { separate } from "../../../Seprate/Seprate";
import { Button, Popover, Radio } from "antd";
import { facturePayApi } from "../../../Api/BarestServices";
import { errorToast, succToast } from "../../../Toast/Toast";
import { payBarestHelpInstallment } from "../../../Api/ClientServices";
const TransactionInfo = ({ data,updateData }) => {
    const [loadingState, setLoadingState] = useState(false);
      const [paymentTypeState, setPaymentTypeState] = useState("pgw");
  const transactionSituationHandler = (item) => {
    const amount = parseFloat(item.amount);
    switch (item.status) {
      case "1":
        if (amount > 0) {
          return "شارژ حساب";
        } else {
          return "برداشت از حساب";
        }
      case "0":
        return "قسط پرداخت نشده";
      case "2":
        return "قسط پرداخت شده";

      default:
        break;
    }
  };
  const transactionSituationStyle = (item) => {
    const amount = parseFloat(item.amount);
    switch (item.status) {
      case "1":
        if (amount > 0) {
          return "#007be0";
        } else {
          return "#c20078";
        }
      case "0":
        return "gray";
      case "2":
        return "green";

      default:
        break;
    }
  };
  const payFacturHandler = (id) => {
      setLoadingState(true);
      const info = {
        id: id,
        payment_type: paymentTypeState,
      };
      payBarestHelpInstallment(info, (succ,res) => {
        if (res.status === 1) {
          succToast("درخواست شما ثبت شد");
          if (paymentTypeState === "pgw") {
            window.open(res.link, "_self");
          }
          setTimeout(() => {
            updateData()
          }, 1000);
          setLoadingState(false);
        } else {
          errorToast(res.message);
          setLoadingState(false);
        }
      });
    };
  const paymentType=(id) => (
      <div className={Style.paymentHolder}>
        <Radio.Group
          onChange={(e) => setPaymentTypeState(e.target.value)}
          value={paymentTypeState}
          style={{
            display: "flex",
            flexDirection: "column",
            direction: "rtl",
            width: "100%",
          }}
          options={[
            { value: "wallet", label: "کیف پول" },
            { value: "pgw", label: "پرداخت آنلاین" },
            { value: "debt", label: "کمک برست" },
          ]}
        />
        <Button
          type="primary"
          onClick={()=>payFacturHandler(id)}
          loading={loadingState}
          disabled={loadingState}
        >
          پرداخت
        </Button>
      </div>
    );
  return (
    <>
      {data?.map((item) => (
        <section
          key={item.id}
          className={Style.transactionCard}
          style={{ border: `1px solid ${transactionSituationStyle(item)}` }}
        >
          <h5 style={{ background: transactionSituationStyle(item) }}>
            وضعیت: {transactionSituationHandler(item)}
            {parseInt(item.status)===0&&<Popover
            overlayInnerStyle={{ direction: "rtl" }}
            destroyTooltipOnHide={true}
            content={()=>paymentType(item.id)}
            title="نوع پرداخت رو انتخاب کنید"
            trigger="click"
          >
            <button>پرداخت {separate(item?.amount)} تومان</button>
          </Popover>}
          </h5>
          <div className={Style.transactionCardInfo}>
            <p>تاریخ :{convertDate(item.date, false)}</p>
            <p>
              مبلغ:
              <strong style={{ color: "green" }}>
                {separate(item.amount)} تومان
              </strong>
            </p>
          </div>
          
        </section>
      ))}
    </>
  );
};

export default TransactionInfo;
